import { MATCH_THRESHOLD, SUB_MATCH_THRESHOLD, type InterestAssetMatchScore } from '@aikoa/common'
import type { LeadManualFilter } from './leadStore'

export function getLeadName(name: string) {
  return !name || name === '<redacted>' ? false : name
}

export function hasManualLeadFilter(manualFilter?: LeadManualFilter) {
  if (!manualFilter) {
    return false
  }

  if (manualFilter.locations.length > 0) {
    return true
  }

  const { filters } = manualFilter

  if (filters.buildingTypes && filters.buildingTypes.length > 0) {
    return true
  }

  if (filters.conditions && filters.conditions.length > 0) {
    return true
  }

  if (typeof filters.priceMin === 'number' || typeof filters.priceMax === 'number') {
    return true
  }

  if (typeof filters.sizeMin === 'number' || typeof filters.sizeMax === 'number') {
    return true
  }

  if (typeof filters.roomsMin === 'number' || typeof filters.roomsMax === 'number') {
    return true
  }

  if (typeof filters.buildYearMin === 'string') {
    if (filters.buildYearMin.trim().length > 0) {
      return true
    }
  } else if (typeof filters.buildYearMin === 'number') {
    return true
  }

  if (typeof filters.buildYearMax === 'string') {
    if (filters.buildYearMax.trim().length > 0) {
      return true
    }
  } else if (typeof filters.buildYearMax === 'number') {
    return true
  }

  return false
}

export function validateLeadMatchScores(leadMatchScores?: InterestAssetMatchScore) {
  return (
    !!leadMatchScores?.match_score &&
    leadMatchScores.match_score >= MATCH_THRESHOLD &&
    Object.entries(leadMatchScores).every(([key, score]) => {
      return (
        !key.endsWith('_score') || (score ?? null) === null || Number(score) >= SUB_MATCH_THRESHOLD
      )
    })
  )
}
